<template>
  <el-container class="workload_list">
    <el-main>
      <div style="display: flex;justify-content: flex-start;">
        <el-button type="primary" icon="el-icon-plus" size="mini" @click="addWorkload">添加</el-button>
      </div>
      <div style="display: flex;justify-content: center;display:inline;">
        <el-date-picker v-model="workMonth" format="yyyy-MM" value-format="yyyy-MM" type="month"  placeholder="选择月" size="small"></el-date-picker>
        <el-select v-model="deptId" size="small" placeholder="选择机构" style="width:200px">
          <el-option label="选择机构" :key="0" :value="0"/>
            <el-option
              @click.native="handleSelectDept(item.id)"
              v-for="item in depts"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
        </el-select>
        <el-select v-model="projectId" size="small" placeholder="选择项目" style="width:350px">
            <el-option
              @click.native="handleSelectProject(item.id)"
              v-for="item in projects"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
        </el-select>
        <el-select v-model="userId" size="small" filterable placeholder="选择用户" style="width:100px">
          <el-option label="选择用户" :key="0" :value="0"/>
            <el-option
              @click.native="handleSelectUser(item.id)"
              v-for="item in users"
              :key="item.id"
              :label="item.loginName"
              :value="item.id"
            ></el-option>
        </el-select>
        <el-button
          type="primary"
          icon="el-icon-search"
          size="mini"
          style="margin-left: 3px"
          @click="searchClick"
        >搜索</el-button>
      </div>
      <el-table
        ref="multipleTable"
        :data="workloads"
        tooltip-effect="dark"
        style="width: 100%;overflow-x: hidden; overflow-y: hidden;"
        max-height="560"
        @selection-change="handleSelectionChange"
        v-loading="loading"
      >
        <el-table-column type="selection" width="60" align="left" v-if="showEdit || showDelete"></el-table-column>
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column prop="projectName" label="项目名称" width="300" align="center" ></el-table-column>
        <el-table-column prop="deptName" label="所属部门" width="100" align="center"></el-table-column>
        <el-table-column prop="loginName" label="用户名" width="100" align="center"></el-table-column>
        <el-table-column prop="workDate" label="工作日期" width="100" align="center" :formatter="formatDate"></el-table-column>
        <el-table-column prop="task" label="任务节点" width="100" align="center"></el-table-column>
        <el-table-column prop="benchmarkQuota" label="基准工作量" width="100" align="center"></el-table-column>
        <el-table-column prop="executiveQuota" label="执行工作量" width="100" align="center"></el-table-column>
        <el-table-column prop="quantity" label="工作量" width="100" align="center"></el-table-column>
        <el-table-column
          prop="quantityToBenchmark"
          label="转换为基准工作量"
          width="150"
          >
          <template slot-scope="scope">
            <el-tag effect="dark"
              :type="scope.row.quantityToBenchmark >=4800 ? 'success' : 'danger'"
              disable-transitions>{{scope.row.quantityToBenchmark}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="auditStatus" label="审核状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag effect="dark"
              :type="scope.row.auditStatus ==0 ? 'danger' : 'success'"
              disable-transitions>{{statusName(scope.row.auditStatus)}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="auditOpinion" label="审核意见" width="100" align="center"></el-table-column>
        <el-table-column label="操作" align="center" v-if="showEdit || showDelete">
          <template slot-scope="scope">
            <el-button size="mini" @click="editWorkload(scope.$index, scope.row)" v-if="showEdit">编辑</el-button>
            <el-popconfirm
              placement="top"
              width="260"
              icon="el-icon-info"
              iconColor="red"
              title="确定要删除吗？"
              @onConfirm="delWorkload(scope.row.id)">
              <div style="text-align: right; margin: 0">
                <el-button size="mini" type="text" @click="del_confirm_visible = false">取消</el-button>
                <el-button type="primary" size="mini" @click="del_confirm_visible = false">确定</el-button>
              </div>
              <el-button size="mini" type="danger" v-if="showDelete" slot="reference" @click="del_confirm_visible=true">删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <div class="guest_table_footer">
        <el-pagination
          background
          :page-size="pageSize"
          layout="prev, pager, next"
          :total="totalCount"
          @current-change="currentChange"
          v-show="workloads.length>0"
        ></el-pagination>
      </div>
      <div>合计：<span v-text="sum"></span></div>
    </el-main>
    <el-dialog height="600" :title="dlg_title" :visible.sync="dialogVisible" class="guest-dlg" :close-on-click-modal="false">
      <el-form label-width="100px" label-position="right" label-suffix="" :model="formData" ref="formData">
        <el-row type="flex" :gutter="20">
          <el-col :span="8">
            <el-form-item label="选择机构">
              <el-select v-model="formData.deptId" size="small" placeholder="选择机构">
                  <el-option
                  @click.native="handleSelectDept(item.id)"
                    v-for="item in depts"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="项目类别">
              <el-select placeholder="请选择项目类别" size="small" v-model="projectType">
                <el-option
                @click.native="handleSelectType(item.id)"
                  v-for="item in projectTypeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="选择项目">
              <el-select  v-model="formData.projectId" size="small" placeholder="选择项目">
                  <el-option
                    @click.native="handleSelectProject(item.id)"
                    v-for="item in projects"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="选择用户">
              <el-select v-model="formData.userId" size="small" placeholder="选择用户">
                  <el-option
                    v-for="item in users"
                    :key="item.id"
                    :label="item.loginName"
                    :value="item.id"
                  ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="工作日期">
              <el-date-picker
                v-model="formData.workDate"
                type="date"
                :clearable="false"
                value-format="yyyy-MM-dd"
                placeholder="工作日期"
                @blur="
                  blurInput(scope.row.id, 'planStartTime', scope.row.planStartTime)
                "
                v-focus
                size="mini"
                >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="选择任务">
              <el-select v-model="formData.task" size="small" placeholder="选择任务">
                  <el-option
                    @click.native="handleSelectTask(value)"
                    v-for="(value,key) in quota"
                    :key="key"
                    :label="value"
                    :value="value"
                  ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
              <el-form-item label="基准工作量">
                <el-input
                  maxlength="50"
                  v-model="formData.benchmarkQuota"
                  auto-complete="off"
                  size="mini"
                />
              </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
              <el-form-item label="执行工作量">
                <el-input
                  maxlength="50"
                  v-model="formData.executiveQuota"
                  auto-complete="off"
                  size="mini"
                />
              </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="工作量">
              <el-input
                v-model="formData.quantity"
                auto-complete="off"
                size="mini"
              />
            </el-form-item>
          </el-col>
          </el-row>
          <el-row :gutter="20">
          <el-col :span="16">
            <el-form-item label="备注">
              <el-input
                rows="3"
                type="textarea"
                v-model="formData.remark"
                auto-complete="off"
                size="mini"
              />
            </el-form-item>
          </el-col>
          </el-row>
          <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="状态">
              <el-select v-model="formData.auditStatus" size="small" placeholder="状态">
                  <el-option
                    v-for="item in auditStatuses"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="defualt" @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveWorkload">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>
<script>
import { getRequest, postRequest, putRequest } from '../../utils/api'
import { HttpStatus } from '../../utils/httpstatus'
import '../../utils/filter_utils'
import {clearObject} from '../../utils/utils'

export default {
  mounted: function () {
    this.loading = true
    this.loadDepts()
    this.loadWorkloads()
    this.loadUsers()
  },
  data () {
    return {
      projects: [],
      depts: [],
      users: [],
      task: '',
      tasks: [{name: '编页', value: 2}, {name: '扫描'}, {name: '图处'}, {name: '质检'}, {name: '著录'}, {name: '校对'}, {name: '装订'}, {name: '工时'}],
      projectId: '',
      deptId: 0,
      userId: 0,
      workloads: [],
      loading: false,
      pageSize: 200,
      totalCount: 0,
      currentPage: 1,
      selItems: [],
      showEdit: true,
      showDelete: true,
      del_confirm_visible: false,
      sel_del_confirm_visible: false,
      members: [],
      memberIds: '',
      formData: {},
      dlg_title: '请假',
      dialogVisible: false,
      auditStatus: '0',
      auditStatuses: [{name: '待审核', value: 0}, {name: '审核通过', value: 1}],
      quota: [],
      benchmarkQuota: 0,
      workMonth: '',
      sum: 0,
      projectType: 0,
      projectTypeList: [
        {id: 0, name: '未分类'},
        {id: 1, name: '文书档案数字化'},
        {id: 2, name: '人事档案数字化'},
        {id: 3, name: '文书档案整理'},
        {id: 4, name: '其他项目'}
      ]
    }
  },
  methods: {
    formatDate (row, column) {
      // 获取单元格数据
      let data = row[column.property]
      return this.$options.filters['formatDateTimeUctYMD'](data)
    },
    handleSelectDept (id) {
      this.deptId = id
      this.loadProjects()
      this.loadUsers()
    },
    handleSelectType (id) {
      this.projectType = id
      this.loadProjects()
      this.loadUsers()
    },
    handleSelectProject (id) {
      this.projectId = id
      this.loadUsers()
      this.loadDefaultQuota()
    },
    loadDepts () {
      let _this = this
      getRequest('/dept/').then(
        resp => {
          this.depts = resp.data
        },
        resp => {
          _this.$message.error('网络连接错误')
          _this.loading = false
        }
      )
    },
    loadProjects () {
      let _this = this
      var url = '/project/list?page=' + _this.currentPage + '&pageSize=' + _this.pageSize
      if (this.deptId !== 0) {
        url = url + '&deptId=' + encodeURIComponent(this.deptId)
      }
      if (this.projectType !== 0) {
        url = url + '&type=' + encodeURIComponent(this.projectType)
      }
      getRequest(url).then(
        resp => {
          this.projects = resp.data.data.projects
        },
        resp => {
          _this.$message.error('网络连接错误')
          _this.loading = false
        }
      )
    },
    loadUsers () {
      let _this = this
      let url = '/user/list?page=1&pageSize=1000'
      if (this.projectId !== '') {
        url = url + '&projectId=' + encodeURIComponent(this.projectId)
      }
      if (this.deptId !== 0) {
        url = url + '&deptId=' + encodeURIComponent(this.deptId)
      }
      getRequest(url).then(
        resp => {
          this.users = resp.data.data.users
        },
        resp => {
          _this.$message.error('网络连接错误')
          _this.loading = false
        }
      )
    },
    loadWorkloads () {
      const _this = this
      var url = '/workload/list?page=' + _this.currentPage + '&pageSize=' + _this.pageSize
      if (this.projectId !== '') {
        url = url + '&projectId=' + encodeURIComponent(this.projectId)
      }
      if (this.deptId !== 0) {
        url = url + '&deptId=' + encodeURIComponent(this.deptId)
      }
      if (this.userId !== 0) {
        url = url + '&userId=' + encodeURIComponent(this.userId)
      }
      if (this.workMonth !== '') {
        url = url + '&workMonth=' + encodeURIComponent(this.workMonth)
      }
      getRequest(url).then(
        resp => {
          _this.workloads = resp.data.data.workloads
          _this.totalCount = resp.data.data.totalCount
          _this.sum = resp.data.data.sum
          _this.loading = false
        },
        resp => {
          _this.$alert('网络连接错误')
          _this.loading = false
        }
      )
    },
    addWorkload () {
      this.dialogVisible = true
      this.formData = {}
      this.dlg_title = '添加'
    },
    editWorkload (index, row) {
      this.dialogVisible = true
      this.workloadId = row.id
      this.deptId = row.deptId
      this.loadProjects()
      this.projectId = row.projectId
      this.loadDefaultQuota()
      this.loadWorkload()
      this.dlg_title = '编辑'
    },
    loadWorkload () {
      let _this = this
      getRequest('/workload/index/' + this.workloadId).then(
        resp => {
          this.formData = resp.data
        },
        resp => {
          _this.$message.error('网络连接错误')
          _this.loading = false
        }
      )
    },
    saveWorkload () {
      const _this = this
      clearObject(this.formData)
      postRequest('/workload/add', this.formData).then(resp => {
        if (resp.data.status === HttpStatus.OK) {
          _this.$alert(resp.data.msg)
          _this.dialogVisible = false
          this.loadWorkloads()
        } else {
          _this.$alert(resp.data.msg)
        }
      },
      resp => {
        _this.$alert('网络错误，请重试')
      })
    },
    delWorkload (id) {
      let _this = this
      putRequest('/workload/del/' + id).then(
        resp => {
          _this.$message.success('删除成功')
          this.loadWorkloads()
        },
        resp => {
          _this.$message.error('网络连接错误')
          _this.loading = false
        }
      )
    },
    currentChange (currentPage) {
      this.currentPage = currentPage
      this.loading = true
      this.loadWorkloads()
    },
    handleSelectionChange (val) {
      this.selItems = val
    },
    searchClick () {
      this.loadWorkloads()
    },
    itemClick (row) {
      this.handleEdit(0, row)
      // this.$router.push({ path: '/blogDetail', query: { aid: row.id } })
    },
    statusName (ststus) {
      return ststus === 0 ? '待审核' : '审核通过'
    },
    handleSelectTask (item) {
      var quotaTmp = JSON.parse(this.benchmarkQuota)
      this.formData.benchmarkQuota = quotaTmp[item]
    },
    loadDefaultQuota () {
      for (var i = 0; i < this.projects.length; i++) {
        if (this.projects[i].id === this.projectId) {
          let jsonitem = JSON.parse(this.projects[i].quota)
          this.benchmarkQuota = this.projects[i].quota
          var arrTmp = []
          for (var item in jsonitem) {
            arrTmp.push(item)
          }
          this.quota = arrTmp
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/Views/Workload/WorkloadMana.vue